module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "page_ix"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "centerp"
  }, [_vm._v("TROTSKY’S ‘FATAL’ FAMILY TREE")]), _vm._v(" "), _c('div', {
    staticClass: "image_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f00ix-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "captionf"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Notes")])]), _vm._v(" "), _c('p', {
    staticClass: "captionf1"
  }, [_vm._v("Dates in "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("bold")]), _vm._v(" font = shot/assassinated/mysterious circumstances/suicide. ? = fate unknown.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-229f1858","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/07_Familytree.vue
// module id = 78
// module chunks = 0